import { CustomValidators } from 'shared/validation/custom-validators';

/* eslint-disable */
export const profileSegmentData: any = [
  {
    // "item_name": "ZZZ-FIRST",
    "field_map": "firstName",
    "item_name": "first_name",
    "title": "First name",
    "hint_detail": "First name",
    "hint_panel" : "First name",
    "example": "",
    "sequence": 1,
    "show_more": true,
    "lookup": null,
    "validation": {
      'PROFILE_VALIDATION': {
        required: true,
        maxLength: 60,
        message: 'First name must be provided and may not be longer than 60 characters'
      },
    },
  },
  {
    // "item_name": "ZZZ-LST",
    "field_map": "lastName",
    "item_name": "last_name",
    "title": "Last name",
    "hint_detail": "Last name",
    "hint_panel" : "Last name",
    "example": "",
    "sequence": 2,
    "show_more": true,
    "lookup": null,
    "validation": {
      'PROFILE_VALIDATION': {
        required: true,
        maxLength: 60,
        message: 'Last name must be provided and may not be longer than 60 characters'
      },
    },
  },
  {
    // "item_name": "ZZZ-EMAIL",
    "field_map": "email",
    "item_name": "email",
    "title": "Email address",
    "hint_detail": "Email address",
    "hint_panel" : "Email address",
    "example": "",
    "sequence": 3,
    "show_more": true,
    "lookup": null,
    "validation": {
      'PROFILE_VALIDATION': {
        required: true,
        maxLength: 254,
        validator: CustomValidators.email,
        message: 'A valid email must be provided and may not be longer than 254 characters'
      },
    },
  },
  {
    // "item_name": "ZZZ-TITLE",
    "field_map": "title",
    "item_name": "title",
    "title": "Title",
    "hint_detail": "Title",
    "hint_panel" : "Title",
    "example": "",
    "sequence": 4,
    "show_more": true,
    "lookup": null
  },
  {
    // "item_name": "ZZZ-PHONE",
    "field_map": "phone",
    "item_name": "phone",
    "title": "Phone number",
    "hint_detail": "Phone number",
    "hint_panel" : "Phone number",
    "example": "",
    "sequence": 5,
    "show_more": true,
    "lookup": null,
    "validation": {
      'PROFILE_VALIDATION': {
        maxLength: 255,
        message: 'Phone cannot be longer than 255 characters.'
      },
    }
  },
  {
    // "item_name": "ZZZ-INSTA",
    "field_map": "instagram",
    "item_name": "instagram",
    "title": "Instagram",
    "hint_detail": "Instagram",
    "hint_panel" : "Instagram",
    "example": "",
    "sequence": 6,
    "show_more": true,
    "lookup": null
  },
  {
    // "item_name": "ZZZ-FB",
    "field_map": "facebook",
    "item_name": "facebook",
    "title": "Facebook",
    "hint_detail": "Facebook",
    "hint_panel" : "Facebook",
    "example": "",
    "sequence": 7,
    "show_more": true,
    "lookup": null
  },
  {
    // "item_name": "ZZZ-LKIN",
    "field_map": "linkedin",
    "item_name": "linkedin",
    "title": "LinkedIn",
    "hint_detail": "LinkedIn",
    "hint_panel" : "LinkedIn",
    "example": "",
    "sequence": 8,
    "show_more": true,
    "lookup": null
  },
  {
    // "item_name": "ZZZ-TWTR",
    "field_map": "twitter",
    "item_name": "twitter",
    "title": "Twitter",
    "hint_detail": "Twitter",
    "hint_panel" : "Twitter",
    "example": "",
    "sequence": 9,
    "show_more": true,
    "lookup": null
  },
]
/* eslint-enable */
